import { Box } from '@mui/material';

import AssetHistoryTable from '~/components/cars/AssetHistoryTable';
import type { CarHistoryEventTypeEnum } from '~/data/generated/model';
import useCarHistory from '~/data/hooks/useCarHistory';

export interface AssetHistoryContentProps {
  carId: string;
}

/** Every event type. The table filters in its own toolbar, so the fetch is unfiltered. */
const ALL_TYPES: CarHistoryEventTypeEnum[] = [];

/** The asset history body: the car's events as a table, rendered in the elevator page's history tab. */
export default function AssetHistoryContent({ carId }: AssetHistoryContentProps) {
  const { events, loading } = useCarHistory(carId, ALL_TYPES);

  return (
    <Box sx={{ p: 3, width: '100%' }}>
      <AssetHistoryTable events={events} loading={loading} />
    </Box>
  );
}
